import { store } from '@betacrew/jars-flux';
import { all, call, put, takeEvery, takeLeading, takeLatest } from 'redux-saga/effects';
import Form1094cDataService from '../../../../services/Form1094cDataService';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { FORM1094C_LOADING_STATES } from './constants';
import { componentKey, setFormDataFromRecordId, setIsIncorrectFormRecordId, setLoadingState, setSuccessfullySubmitted1094c, setTempFormFieldsList, updateFormsPreLoadedData, updateUserInteractionPopupWResponseObj } from './Form1094cSlice';

export const { getFormsList, onDependentFieldChangeGetValues, getFormPreloadedData, getForm1094cFields, save1094cForm } = {
    getFormPreloadedData: (payload) => {
        return {
            type: "FORM_1094C/GET_PRELOADED_DATA",
            payload: payload
        }
    },
    onDependentFieldChangeGetValues: (payload) => {
        return {
            type: "FORM_1094C/ONDEPENDENT_FIELD_CHANGE_VALUES",
            payload: payload
        }
    },
    getForm1094cFields: (payload) => {
        return {
            type: "FORM_1094C/GET_FORM_FIELDS",
            payload: payload
        }
    },
    save1094cForm: (payload) => {
        return {
            type: "FORM_1094C/SAVE_FORM",
            payload: payload
        }
    },
}

function* getFormPreloadedDataAsync(action) {
    try {
        const {formsPreLoadedData, getFormFieldsFlag, toCreateFormData, formId, payerId, year, isFormEditMode, formRecordId} = action.payload;
        yield put(setLoadingState({ state: FORM1094C_LOADING_STATES.CONFIGURATIONS_LOADING }));
        
        let recordIdResponse;
        let formPreLoadedDataResponse;

        if(isFormEditMode){
            recordIdResponse = yield call(Form1094cDataService.getFormByRecordId, formId, formRecordId);
            formPreLoadedDataResponse = yield call(Form1094cDataService.getFormData, formId, year, payerId);
        }else{
            formPreLoadedDataResponse = yield call(Form1094cDataService.getFormData, formId, year, payerId);
        }

        let returnedFormRecordIdData = null;
        let stopHere = false;

        if(isFormEditMode){
            if(recordIdResponse.data){
                if(recordIdResponse?.data?.Status === 1){
                    returnedFormRecordIdData = recordIdResponse?.data?.Data;
                    yield put(setFormDataFromRecordId(returnedFormRecordIdData));
                }else{
                    yield put(addNotifications({
                        heading: "Error",
                        message: recordIdResponse?.data?.Message,
                        variant: TOASTER_VARIANT.DANGER
                    }));
                    yield put(setIsIncorrectFormRecordId(true));
                    stopHere = true;
                }
            }
        }
        if(!stopHere){
            if(formPreLoadedDataResponse.data){
                if(formPreLoadedDataResponse?.data?.Status === 0){
                    yield put(addNotifications({
                        heading: "Error",
                        message: formPreLoadedDataResponse?.data?.Message,
                        variant: TOASTER_VARIANT.DANGER
                    }));
                }else if(formPreLoadedDataResponse?.data?.Status === 1){
                    let tempFormsPreLoadedData = {};
                    const returnedFormData = formPreLoadedDataResponse?.data?.Data ?? {};
                    for (const key in returnedFormData) {
                        if(returnedFormData[key]){
                            tempFormsPreLoadedData[key] = returnedFormData[key];
                        }
                    }
                    yield put(updateFormsPreLoadedData({...tempFormsPreLoadedData}));
        
                    if(getFormFieldsFlag){
                        yield call(getForm1094cFieldsAsync, { payload: { formName: formId, year: year, payerId: payerId, toCreateFormData: toCreateFormData, formsPreLoadedData: {
                            ...formsPreLoadedData,
                            ...tempFormsPreLoadedData,
                        },
                        returnedFormRecordIdData: returnedFormRecordIdData,
                        isFormEditMode: isFormEditMode,
                     } });
                    }
                }
            }
        }
    }catch(error){
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: FORM1094C_LOADING_STATES.CONFIGURATIONS_READY }))
    }
}

function* getForm1094cFieldsAsync(action) {
    try {
        const {formName, year, payerId, toCreateFormData, formsPreLoadedData, returnedFormRecordIdData, isFormEditMode} = action.payload;
        yield put(setLoadingState({ state: FORM1094C_LOADING_STATES.CONFIGURATIONS_LOADING }));
        
        const response = yield Form1094cDataService.getFormFields(formName, year, payerId);
        if(response.data){
            if(response?.data?.Status){
                const updatedFieldsList = response?.data?.Data.map((item) => {
                    
                    const prepopulateField = formsPreLoadedData.hasOwnProperty(item?.FrontEndSource) ? formsPreLoadedData[item?.FrontEndSource] : null;
                    if(isFormEditMode && returnedFormRecordIdData.hasOwnProperty(item?.Name)){
                        return {
                            ...item,
                            inputValue: returnedFormRecordIdData[item?.Name],
                        }
                    } else if(item.Name === "FormName"){
                        return {
                            ...item,
                            inputValue: toCreateFormData?.selectedForm?.FormId ?? null,
                        }
                    }
                    else if (!Array.isArray(prepopulateField) && typeof prepopulateField !== "object" && prepopulateField !== null) {
                        return {
                          ...item,
                          inputValue: prepopulateField,
                        };
                    }
                    return item;
                });
                yield put(setTempFormFieldsList(updatedFieldsList));
            }else{
                yield put(addNotifications({
                    heading: "Failed to get the fields",
                    message: response.data.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    }catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: "We are facing some error. Please try again",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: FORM1094C_LOADING_STATES.CONFIGURATIONS_READY }));
    }
}

function* onDependentFieldChangeGetValuesAsync(action){
    try {
        yield put(setLoadingState({ state: FORM1094C_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING }));
        const response = yield Form1094cDataService.calculateInferredValues(action.payload);
        if(response.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                if(response?.data?.Data?.interaction){
                    yield put(updateUserInteractionPopupWResponseObj({
                        ...response.data.Data.interaction
                    }));
                }
                const responseDataArray = response?.data?.Data?.allFields ?? [];
                yield put(setTempFormFieldsList(responseDataArray));
            }
        }
    } catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: FORM1094C_LOADING_STATES.DEPENDENT_FIELD_CHANGE_READY }))
    }
}

function* save1094cFormAsync(action) {
    try {
        const {formData} = action.payload;
        yield put(setLoadingState({ state: FORM1094C_LOADING_STATES.SAVE_FORM_LOADING }));
        const response = yield Form1094cDataService.saveForm(formData);
        if(response.data){
            if(response?.data?.Status === 0){
                let additionalErrorMessage = "";
                if (response?.data?.Data) {
                    const resultData =  response?.data?.Data;
                    for (const key in resultData) {
                        if (resultData.hasOwnProperty(key)) {
                            const messages = resultData[key].join('<br/>');
                            additionalErrorMessage += `${messages}<br/>`;
                        }
                    }
                }else{
                    additionalErrorMessage = response?.data?.Message;
                }
                yield put(addNotifications({
                    heading: "Error",
                    message: additionalErrorMessage,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else if(response?.data?.Status === 1){
                yield put(addNotifications({
                    heading: "Success",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.SUCCESS
                }));
                yield put(setSuccessfullySubmitted1094c(true));
            }
        }
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: FORM1094C_LOADING_STATES.SAVE_FORM_READY }))
    }
}



function* rootSaga() {
    yield all([
        takeLatest(getFormPreloadedData().type, getFormPreloadedDataAsync),
        takeLatest(getForm1094cFields().type, getForm1094cFieldsAsync),
        takeLatest(onDependentFieldChangeGetValues().type, onDependentFieldChangeGetValuesAsync),
        takeLatest(save1094cForm().type, save1094cFormAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);